import { render } from "./SymptomsTable.vue?vue&type=template&id=7b2dfe44&scoped=true"
import script from "./SymptomsTable.vue?vue&type=script&lang=js"
export * from "./SymptomsTable.vue?vue&type=script&lang=js"

import "./SymptomsTable.vue?vue&type=style&index=0&id=7b2dfe44&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2dfe44"]])

export default __exports__